import { giphyDarkestGrey, giphyLightGrey } from '@giphy/colors'
import { useContext } from 'react'
import styled from 'styled-components'
import CreationToolStatus from '../../../../../types/status'
import UploadButton from '../../../../upload-button'
import { INewCaptureInfo } from '../../types'
import { CreationCaptureInfoContext } from './manager'

const Container = styled.div`
    background: ${giphyDarkestGrey};
    bottom: 0;
    color: ${giphyLightGrey};
    margin: 0 -10px -30px;
    padding-bottom: 10px;
    position: sticky;
    text-align: center;
`

const CancelButton = styled.div`
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin: 20px auto;
`

type Props = {
    saveLabel: string
    uploadProgress?: number
    isUploading?: boolean
    onSave: (info: INewCaptureInfo) => void
    onCancel: () => void
}

const CreationCaptureInfoButtons = ({
    saveLabel,
    isUploading = false,
    uploadProgress = 0,
    onSave,
    onCancel,
}: Props) => {
    const {
        title,
        username,
        tags,
        watermark,
        isWatermarkOpen,
        font,
        rating,
        sourceUrl,
        watermarkPosition,
        segmentationType,
        segmentationMinLength,
        segmentationMaxLength,
        cropType,
        captionStyle,
        isPublic,
        caption,
        autoCaption,
        autoCrop,
        language,
        description,
    } = useContext(CreationCaptureInfoContext)
    const uploadingLabel = CreationToolStatus.label(CreationToolStatus.Uploading)

    return (
        <Container>
            <UploadButton
                {...{
                    isUploading,
                    disabled: (!title && !isWatermarkOpen) || (isWatermarkOpen && !watermark),
                    progress: uploadProgress,
                    onClick: () =>
                        // TODO: Figure out how to move this logic to a better location.
                        onSave({
                            title,
                            username,
                            tags,
                            watermark,
                            font,
                            rating,
                            sourceUrl,
                            watermarkPosition,
                            isPublic,
                            segmentationType,
                            segmentationMinLength,
                            segmentationMaxLength,
                            cropType,
                            caption,
                            captionStyle,
                            autoCaption,
                            autoCrop,
                            language,
                            description,
                        }),
                }}
            >
                {isUploading ? uploadingLabel : saveLabel}
            </UploadButton>
            <CancelButton style={isUploading ? { opacity: 0.5, pointerEvents: 'none' } : {}} onClick={onCancel}>
                Cancel
            </CancelButton>
        </Container>
    )
}

export default CreationCaptureInfoButtons
